import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";
import { retrieveToken } from "../../../utils/storage";

export const userCalendarApi = createApi({
    reducerPath: "userCalendar",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
    }),
    endpoints: (builder) => ({
        getUserCalendar: builder.query({
            query: () => ({
                url: endpoint.USER_CALENDAR.CALENDAR,
                method: "GET",
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`,
                },
            }),
        }),

    })
})

export const { useGetUserCalendarQuery } = userCalendarApi